import {
  SURVEY_OPTION_NONE_ID,
  SURVEY_OPTION_NONE_LABEL,
  SURVEY_OPTION_OTHER_ID,
  SURVEY_OPTION_OTHER_LABEL,
} from './survey-option-ids'
import type { SurveyOption, SurveyQuestion } from './survey-question.types'

/** Deterministic shuffle (Fisher–Yates) so option order is stable per session. */
export function shuffleOptionsDeterministic<T>(items: readonly T[], seed: string): T[] {
  const out = [...items]
  let h = 0
  for (let i = 0; i < seed.length; i++) {
    h = Math.imul(31, h) + (seed.codePointAt(i) ?? 0)
    h = Math.trunc(h)
  }
  for (let i = out.length - 1; i > 0; i--) {
    h = Math.imul(h ^ (h >>> 16), 2246822507)
    h = Math.imul(h ^ (h >>> 13), 3266489909)
    h ^= h >>> 16
    const j = ((h >>> 0) % (i + 1) + (i + 1)) % (i + 1)
    ;[out[i], out[j]] = [out[j], out[i]]
  }
  return out
}

function appendSpecialOptions(question: SurveyQuestion, base: SurveyOption[]): SurveyOption[] {
  const out = [...base]
  if (question.hasOtherOption) {
    out.push({ id: SURVEY_OPTION_OTHER_ID, label: SURVEY_OPTION_OTHER_LABEL, imageUrl: null })
  }
  if (question.hasNoneOfAboveOption) {
    out.push({ id: SURVEY_OPTION_NONE_ID, label: SURVEY_OPTION_NONE_LABEL, imageUrl: null })
  }
  return out
}

/** Display order for choice questions — randomize + synthetic Other/None rows. */
export function resolveDisplayOptions(question: SurveyQuestion, seed: string): SurveyOption[] {
  let opts = [...question.options]
  if (question.randomizeOrder && opts.length > 1) {
    opts = shuffleOptionsDeterministic(opts, `${seed}:${question.id}`)
  }
  return appendSpecialOptions(question, opts)
}
